import * as swcHelpers from '@swc/helpers';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import { getLocalizedAttribute } from '../../../utils/get-line-item-localized-attribute.js';
import { getLineItemPrice } from '../../../utils/get-line-item-price.js';
import { getProductUrl } from '../../../utils/get-line-item-product-url.js';
import { getLocalizedString } from '../../../utils/get-localized-string.js';
import { getSharedProps } from '../../../utils/shared-line-item-data-mapper.js';
import { getBundledLineItemProductVariant } from './utils/bundles/get-bundled-line-item-product-variant.js';
import { getBundledProductInfo } from './utils/prescription-glasses/get-bundled-product-info.js';
import '../../../models/line-item/prescription-glasses.js';

const mapNonPrescriptionBundleLineItem = (lineItemRaw, settings, intl)=>{
    const { locale  } = intl;
    const mainBundleLineItem = lineItemRaw.bundleLineItems.find((bundleLineItem)=>bundleLineItem.isMainBundleLineItem
    );
    if (!mainBundleLineItem) {
        console.error(`None of the bundleLineItems have isMainBundleLineItem in LineItemBundle with id ${lineItemRaw.id}`);
        return null;
    }
    // There are more bundled items in bundleLineItems than just the configurationBundle (aka offering)
    // but only the configurationBundle is needed for the view in cart and checkout
    const configurationBundleItem = lineItemRaw.bundleLineItems.find((item)=>item.legacyProduct.productType === 'configurationbundle'
    );
    if (!configurationBundleItem) {
        console.error(`None of the bundleLineItems is a configurationbundle in LineItemBundle with id ${lineItemRaw.id}`);
        return null;
    }
    const shared = getSharedProps(lineItemRaw, mainBundleLineItem.legacyProduct, intl);
    const variant = getBundledLineItemProductVariant(mainBundleLineItem);
    const slug = getLocalizedString(locale, mainBundleLineItem.legacyProduct.masterData.current.slug);
    const offering = getBundledProductInfo(configurationBundleItem, intl);
    const mainBundleItemPrice = mainBundleLineItem.price ? getLineItemPrice(mainBundleLineItem.price, intl.locale).unit : undefined;
    return swcHelpers.objectSpread({}, shared, {
        type: 'non-prescription-bundle',
        imageUrl: getLineItemImageUrl(variant),
        name: getLocalizedString(locale, mainBundleLineItem.legacyProduct.masterData.current.name),
        productUrl: getProductUrl(settings.productLinkFormatter, lineItemRaw, slug, locale),
        productId: lineItemRaw.id,
        sku: lineItemRaw.sku,
        mainBundleItemPrice,
        offering,
        brand: {
            name: getAttribute(variant, 'brand'),
            model: getAttribute(variant, 'brandModel'),
            modelCode: getAttribute(variant, 'brandModelCode'),
            modelColorCode: getAttribute(variant, 'brandModelColorCode')
        },
        erpId: getAttribute(variant, 'erpId'),
        frame: {
            frameType: getLocalizedAttribute(variant, 'frameType', 'en'),
            faceShape: getLocalizedAttribute(variant, 'faceShape', 'en')
        }
    });
};

export { mapNonPrescriptionBundleLineItem };
//# sourceMappingURL=non-prescription-bundle.js.map
